module.exports = __webpack_public_path__ + "img/20210407_164806.c8d561a5.jpg";